import type { ReactNode } from 'react';
import type { AppRole } from '../types/auth';
import { useAuth } from './useAuth';

interface RoleGuardProps {
  allowedRoles: AppRole[];
  children: ReactNode;
}

/**
 * Role-based guard — renders children only if the user has at least
 * one of the allowed roles. Shows access-denied with current roles otherwise.
 */
export default function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
  const { roles, logout } = useAuth();

  const hasAccess = roles.some((r) => allowedRoles.includes(r));

  if (hasAccess) {
    return <>{children}</>;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <h1 style={{ color: '#d32f2f', marginBottom: '0.5rem' }}>Access Denied</h1>
      <p style={{ color: '#555', marginBottom: '1rem' }}>
        You don't have permission to view this page.
      </p>
      <p style={{ color: '#777', marginBottom: '2rem' }}>
        Your current roles: {roles.length > 0 ? roles.join(', ') : 'none assigned'}
      </p>
      <button
        onClick={() => void logout()}
        style={{
          padding: '0.5rem 1.5rem',
          fontSize: '1rem',
          borderRadius: '4px',
          border: '1px solid #ccc',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer',
        }}
      >
        Sign out
      </button>
    </div>
  );
}
